电话输入框，包含国号，区号和号码

<template>
  <el-form-item :label="title" :id="field.FIELD_ID" :ref="field.FIELD_ID" :class="itemClass" v-if="isShow"
    :prop="field.FIELD_ID" :rules="rules">
    <div class="telephone">
      <el-input v-if="isShowCode" class="area-no" type="number" :maxlength="5" :disabled="isDisabled" v-model="areaNo"></el-input>
      <div v-if="isShowCode">-</div>
      <el-input class="phone-no" type="number" :maxlength="phoneNoMaxLength" :disabled="isDisabled" v-model="phoneNo"></el-input>
    </div>
  </el-form-item>
</template>

<script>
import validateRules from "./validateRules";

export default {
  data () {
    return {
      itemClass: "self-telephoneInput",
      countryNo: "+86",
      areaNo: "",
      phoneNo: "",
      isDisabled: false,
      triggerType: ["change", "blur"],
      rules: [],
      phoneNoMaxLength: 11
    };
  },
  props: ["field", "index", "isBaseUI"],
  created () {
    switch (this.$bizcfg.getBizConfigName()) {
      case "ZHONGTAI":
        this.phoneNoMaxLength = 13;
        break;
      default:
        this.countryNo = "+86";
    }
    this.rules.push({ validator: this.validatorField, trigger: this.triggerType });
  },
  mounted () {
    this.itemClass += " " + this.field.FIELD_ID;

    if (this.isRequired)
      this.itemClass += " self-telephoneInput-required";

    if (this.isShowChange)
      this.itemClass += " self-telephoneInput-changed";

    this.initData();
  },
  computed: {
    title: function () {
      this.field.FIELD_TITLE = this.field.FIELD_TITLE.replace("\\n", "\n");
      return _.trim(this.field.FIELD_TITLE) ? this.field.FIELD_TITLE
        + (_.intersection(this.field.FIELD_TITLE.split(""), ["：", ":"]).length ? "" : "：") : "";
    },
    isRequired: function () {
      return parseInt(this.field.FIELD_REQUIRED) ? true : false;
    },
    isShow: function () {
      let fieldControl = parseInt(this.field.FIELD_CONTROL);
      if (fieldControl == 2) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }

      if (fieldControl === 0 || fieldControl === 2) {
        return true;
      } else {
        return false;
      }
    },
    dataChange: function () {
      return this.field.DEFAULT_VALUE;
    },
    isShowChange: function () {
      return this.field.showchange;
    },
    isShowCountryCode: function () {
      //telPhoneType 0显示国际区号和城市区号
      if (this.field.telPhoneType == 0) {
        return true;
      } else {
        return false;
      }
    },
    isShowCode: function () {
      //telPhoneType 0显示国际区号和城市区号 1只显示城市区号 2只显示电话
      if (this.field.telPhoneType == 0 || this.field.telPhoneType == 1) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    initData () {
      if (this.field.DEFAULT_VALUE) {
        if (this.field.telPhoneType == "2") {
          this.phoneNo = this.field.DEFAULT_VALUE;
          return;
        }
        let phones = this.field.DEFAULT_VALUE.split("-");
        if (phones.length == 3) {
          this.countryNo = phones[0];
          this.areaNo = phones[1];
          this.phoneNo = phones[2];
        } else if (phones.length == 2) {
          this.areaNo = phones[0];
          this.phoneNo = phones[1];
        } else {
          this.phoneNo = phones[0];
        }
      } else {
        this.countryNo = "+86";
        this.areaNo = "";
        this.phoneNo = "";
      }

      let fak = this.field.FIELD_ID + "_QUHAO";
      this.field.FIELD_ADDITION = {};
      this.field.FIELD_ADDITION[fak] = this.countryNo;
    },
    validatorField: function (rule, val, callback) {
      this.$nextTick(() => {
        let values = [this.countryNo.trim(), this.areaNo.trim(), this.areaNo.trim() + this.phoneNo.trim()];
        if ((this.field.telPhoneType == 0 && _.trim(values[0]) === "" || this.field.telPhoneType == 1) && _.trim(values[2]) === "" && !this.isRequired) {
          //如果为空 且非必填 直接返回不校验
          this.showErrorMsg = "";
          this.field.correct = true;
          this.field.showerr = false;
          callback();
          return;
        }
        //默认校验3个输入框 国际区号 城市区号 电话号码
        let types = ["tel1", "tel2", "tel3"];
        //telPhoneType： 0 带国际区号 区号 1 只有区号 3无区号
        if (this.field.telPhoneType == 1) {
          values = [this.areaNo, this.areaNo + "-" + this.phoneNo];
          types = ["tel2", "tel3"];
        } if (this.field.telPhoneType == 2) {
          values = [this.phoneNo];
          types = ["tel3"];
        }

        for (let i = 0; i < values.length; i++) {
          let value = values[i];
          let type = types[i];
          if (_.trim(value) === "" && this.isRequired && this.isShow) {
            if (type == "tel1") {
              this.showErrorMsg = "请输入电话国际区号";
            } else if (type == "tel2") {
              this.showErrorMsg = "请输入电话区号";
            } else {
              this.showErrorMsg = "请输入电话号码";
            }
            // this.showErrorMsg = this.field.FIELD_TITLE + "为必填项";
            this.field.correct = false;
            this.field.showerr = true;
            this.field.FIELD_CONTROL = "0";
            callback(new Error(this.showErrorMsg));
            break;
          } else {
            let isError = false;
            let validateRule = validateRules[type];
            if (validateRule && _.trim(value) !== "")
              isError = !validateRule.valid(value, this.field.telPhoneType);
            if (isError) {
              this.showErrorMsg = validateRule.msg;
              this.field.correct = false;
              consoleLog("电话校验失败" + value);
              callback(new Error(this.showErrorMsg));
              break;
            } else if (this.field.message) {
              // 关联逻辑判断中传过来要显示的message
              this.showErrorMsg = this.field.message;
              this.field.correct = false;
              this.field.showerr = true;
              return callback(new Error(this.showErrorMsg));
            } else {
              this.showErrorMsg = "";
              this.field.correct = true;
            }
            if (this.field.correct) {
              this.field.showerr = false;
              this.field.message = "";
              if (this.isBaseUI) {
                this.$emit("field-change", this.field);
              } else {
                this.$store.commit(this.$types.UPDATE_FIELD_CHANGE, { field_id: this.field.FIELD_ID, module_id: this.field.MODULE_ID, index: this.index });
              }
            } else {
              this.field.showerr = true;
              callback(new Error(this.showErrorMsg));
              break;
            }
          }
        }
        callback();
      });
    }
  },
  watch: {
    isRequired: function (val) {
      if (val) {
        this.itemClass += " self-telephoneInput-required";
      } else {
        this.itemClass = this.itemClass.replace(/self-telephoneInput-required/g, "");
      }
    },
    isShowChange: function (val) {
      if (val) {
        this.itemClass += " self-telephoneInput-changed";
      } else {
        this.itemClass = this.itemClass.replace(/self-telephoneInput-changed/g, "");
      }
    },
    countryNo: function (val) {
      let fak = this.field.FIELD_ID + "_QUHAO";
      this.field.FIELD_ADDITION[fak] = val;
    },
    areaNo: function (val) {
      this.field.DEFAULT_VALUE = (val != "" ? val + "-" : "") + this.phoneNo;
    },
    phoneNo: function (val) {
      this.field.DEFAULT_VALUE = (this.areaNo != "" ? this.areaNo + "-" : "") + val;
    },
    dataChange: function (val) {
      this.field.message = "";
      this.initData();
    },
    "field.DATA_SOURCE": {
      handler (val, oldVal) {
        this.itemClass = this.itemClass.replace("ocrIcon","");
        this.itemClass = this.itemClass.replace("zzIcon","");
        this.itemClass = this.itemClass.replace("zdIcon","");
        if (val == "1") {
          this.itemClass += " ocrIcon";
        } else if (val == "2") {
          this.itemClass += " zzIcon";
        } else if (val == "3") {
          this.itemClass += " zdIcon";
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="less">
.self-telephoneInput {
  width: 100%;
  display: flex;
  .el-form-item__label {
    // font-size: 20px;原始vtm
    font-size: 14px;
    color: #343434;
    min-width: 170px;
    text-align: right;
  }
  .el-form-item__content {
    // font-size: 20px;原始vtm
    font-size: 14px;
    color: #000;
    flex: 1;
    .telephone {
      display: flex;
      width: 100%;
      align-items: center;
      .area-no {
        // width: 1px;
        // flex: 2 1 auto;
        // margin: 0 5px;
        width: 1px;
        flex: 1 1 auto;
        margin: 0 5px;
      }
    
      .phone-no {
        width: 1px;
        flex: 3 1 auto;
        margin-left: 5px;
      }
    }
  }
}

.self-telephoneInput-required {
  .el-form-item__label:before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
  }
}

// .self-telephoneInput-changed {
//   input.el-input__inner {
//     background: rgba(252,230,56,0.20) !important;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/preEntry/telephoneInputItem.vue